import { buildApi } from '../../http-client/http-client';
import { toQueryParams } from '../../../utils/common-utils';
import withAuth from '../../auth-service/with-auth';
import * as Models from '../../../models';
import { MapperApi2_0 } from '../../../mappers';
import { Api2_0 } from '@opositatest/universal/mappers/backend-types';

export interface ExamsResponse extends Models.Response.ResourcesList {
  resources: Models.Exam[];
}

type ExamsRequest = {
  'filters[opposition]'?: Models.OppositionId;
  'filters[type]'?: Models.AvailableExamTypes;
  /**
   * 1: Returns only free exams.
   * 0: Returns only paid exams.
   * To get both of them, do not set this filter.
   */
  'filters[isFree]'?: 0 | 1;
  /**
   * 1: Returns only exams included in normal subscription.
   * 0: Returns only exams NOT included in normal subscription.
   * To get both of them, do not set this filter.
   */
  'filters[includedInNormalSubscription]'?: 0 | 1;
  page?: number;
  pageSize?: number;
};

export type ExamsParams = {
  oppositionId?: Models.OppositionId;
  type?: Models.AvailableExamTypes;
  isFree?: boolean;
  isIncludedInNormalSubscription?: boolean;
  page?: number;
  pageSize?: number;
};

export const getExams = withAuth<ExamsResponse, [ExamsParams]>(
  async (token: string, params: ExamsParams = {}): Promise<ExamsResponse> => {
    const { oppositionId, type, isFree, isIncludedInNormalSubscription, page, pageSize } = params;

    const request: ExamsRequest = {
      'filters[opposition]': oppositionId,
      'filters[type]': type,
    };
    if (isFree !== undefined) {
      request['filters[isFree]'] = isFree ? 1 : 0;
    }
    if (isIncludedInNormalSubscription !== undefined) {
      request['filters[includedInNormalSubscription]'] = isIncludedInNormalSubscription ? 1 : 0;
    }
    request.page = page || 1;
    request.pageSize = pageSize;

    const query = toQueryParams(request);

    return buildApi(token)
      .get(`${process.env.ADMIN_API_BASE_URL}/api/v2.0/exams?${query}`)
      .then((data: Models.Response.ResourcesList<Api2_0.Exam>) => {
        return {
          ...data,
          resources: data.resources.map(MapperApi2_0.mapExam),
        };
      });
  },
);
